export default "__VITE_ASSET__DKqGYemy__"